'use client'

import { Card, CardBody } from '@heroui/card'
import { Skeleton } from '@heroui/skeleton'
import { useSuspenseQuery } from '@tanstack/react-query'
import { Suspense } from 'react'

import { FireIcon } from '@/components/shared'
import { InfoIcon } from '@/components/shared/icons'
import { Typography } from '@/components/ui'
import { useApi } from '@/trpc/react'
import { cn } from '@/utils'




// This component assumes data is available (used within Suspense)
const StreakCardContent = () => {
  const api = useApi()
  const { data: streakResponse } = useSuspenseQuery(
    api.streaks.getStreak.queryOptions(),
  )

  const streak = streakResponse?.currentStreak ?? 20

  return (
    <>
      <FireIcon
        className={cn(
          'mb-3 text-2xl',
          streak > 0 ? 'text-secondary' : 'text-default-300',
        )}
      />
      <Typography
        size="4xlarge"
        weight="regular"
        className="text-default-foreground"
      >
        {streak}
        {streak > 99 ? 'd' : streak > 1 || streak === 0 ? ' days' : ' day'}
      </Typography>
    </>
  )
}

// Fallback component to show while loading
const StreakCardFallback = () => {
  return (
    <>
      <FireIcon className={cn('mb-3 text-2xl text-secondary')} />
      <Typography
        size="4xlarge"
        weight="regular"
        className="text-default-foreground"
      >
        <Skeleton className="h-10 w-20" />
      </Typography>
    </>
  )
}

// Main component with Suspense boundary
const StreakCard = () => {
  return (
    <Card
      shadow="none"
      className="col-span-1 cursor-pointer rounded-[36px] border border-primary-100 bg-primary-50"
    >
      <CardBody className="p-6  pt-5">
        <Suspense fallback={<StreakCardFallback />}>
          <StreakCardContent />
        </Suspense>
        <div className="flex items-center gap-1">
          <Typography
            size="xlarge"
            weight="light"
            className="flex items-center font-crimsonPro tracking-[-0.24px] text-content4-foreground"
          >
            Streak
          </Typography>
          <div className="pt-[6px]">
            <InfoIcon className="text-xs text-content4-foreground" />
          </div>
        </div>
      </CardBody>
    </Card>
  )
}

export default StreakCard
